import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, vShow as _vShow, isRef as _isRef, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hy-input-file" }
const _hoisted_2 = { class: "d-flex align-center justify-space-between mb-1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: "d-flex justify-center align-center rounded pa-1",
  style: {"aspect-ratio":"1"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'File',
  setup(__props) {


const { field, control, inputModel, handleUpdate } = inject('input') as InputInjection

const fileInput = ref() as Ref<HTMLInputElement>

// Is this an image file upload?
const imageFile = (field.value.type === 'image')
const uploadIcon = useIconLib(imageFile ? 'Image' : 'File')
// If no specific accept options are given, we will default to any (file) or images (image)
const acceptOptions = field.value.accept || (imageFile ? '.png, .jpg, .jpeg, .gif, image/*' : '')

function resetField() {
  field.value.reset()
}

function handleUpload() {
  // Open file input
  fileInput.value.click()
}


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", {
        class: "text-caption text-truncate",
        innerHTML: _unref(control).label
      }, null, 8, _hoisted_3),
      (_unref(control).help)
        ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
            key: 0,
            "help-prompt": _unref(control).help,
            class: "mr-4"
          }, null, 8, ["help-prompt"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_card, {
      class: "border-thin",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_hover, null, {
            default: _withCtx(({ isHovering, props }) => [
              (_unref(field).display)
                ? (_openBlock(), _createBlock(_component_v_img, _mergeProps({ key: 0 }, props, {
                    src: _unref(field).display,
                    rounded: "lg",
                    "min-height": "50px",
                    class: "hy-file-input-image border rounded hy-pointer"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "fill-height fill-width align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "text-center" }, {
                            default: _withCtx(() => [
                              isHovering
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    density: "compact",
                                    size: "x-small",
                                    height: "30px",
                                    onClick: handleUpload
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_hy_icon, {
                                        name: "Upload",
                                        color: "primary",
                                        small: ""
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040, ["src"]))
                : (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 1,
                    width: "100%",
                    class: "d-flex justify-center align-center hy-pointer repeating-gradient",
                    style: {"aspect-ratio":"1"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        density: "compact",
                        size: "x-small",
                        height: "30px",
                        onClick: handleUpload
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_hy_icon, {
                            name: "Upload",
                            color: "primary",
                            small: ""
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_v_file_input, _mergeProps({
      modelValue: _unref(inputModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null))
    }, _unref(control), {
      ref_key: "fileInput",
      ref: fileInput,
      accept: _unref(acceptOptions),
      "prepend-icon": _unref(uploadIcon),
      "onClick:clear": resetField,
      "onUpdate:modelValue": _unref(handleUpdate)
    }), null, 16, ["modelValue", "accept", "prepend-icon", "onUpdate:modelValue"]), [
      [_vShow, false]
    ])
  ]))
}
}

})